import {StoppageCreate, StoppageEdit} from '@hconnect/common/stoppages/types/stoppage.types'
import {User, RunningTimeDto as RunningTime, EquipmentData} from '@hconnect/common/types'
import {
  appendEquipmentData,
  appendStoppageSplitData,
  appendUser,
  attachmentFilesToFormData
} from '@hconnect/common/utils'

type StoppageActionEvent = StoppageEdit | StoppageCreate

const appendPxTrendStoppage = (formData: FormData, pxTrendStoppage: RunningTime) => {
  for (const key in pxTrendStoppage) {
    if (pxTrendStoppage[key]) {
      formData.append(`pxTrendStoppage[${key}]`, pxTrendStoppage[key] as string)
    }
  }
}

export const prepareStoppagePayload = async (
  event: StoppageActionEvent,
  skipKeys: string[] = []
): Promise<FormData> => {
  const formData = new FormData()
  const keys = Object.keys(event).filter((item) => skipKeys.indexOf(item) < 0)
  for (const key of keys) {
    const value = event[key]
    if (value) {
      switch (key) {
        case 'attachments':
        case 'newAttachments':
          await attachmentFilesToFormData(value, formData)
          break
        case 'attachmentsToRemove':
          value.map((url: string) => formData.append('attachmentsToRemove', url))
          break
        case 'equipment':
          appendEquipmentData(formData, value as EquipmentData)
          break
        case 'createdBy':
          appendUser(formData, value as User, 'createdBy')
          break
        case 'mainEquipment':
          appendEquipmentData(formData, value as EquipmentData, true)
          break
        case 'pxTrendStoppage':
          appendPxTrendStoppage(formData, value as RunningTime)
          break
        case 'originalSplitStoppageId':
          appendStoppageSplitData(formData, value as string, event.stoppageStart)
          break
        default:
          formData.append(key, value as string | Blob)
      }
    }
  }
  return formData
}
